<template>
  <Page :label="title" back :customGradient="classes">
    <carousel
      id="sections-carousel"
      ref="sectionsCarousel"
      classes="pt-4 -my-4 pb-8"
    >
      <section-button
        v-for="(theSection, i) in reorderedSections"
        :key="i"
        :active="section === theSection.path"
        :classes="[i === 0 ? 'ml-8' : '', ' mr-4']"
        :label="theSection.label"
        @onClick="changeSection(theSection.path)"
      />
      <div>&nbsp;</div>
    </carousel>
    <slot></slot>
  </Page>
</template>
<script>
import Carousel from "../Carousel.vue";
import Page from "../Page.vue";
import SectionButton from "../containers/SectionButton";
export default {
  emits: ["changeSection"],
  components: {
    Page,
    Carousel,
    SectionButton,
  },
  props: {
    title: String,
    congressID: Number,
    section: String,
    sections: Array,
    classes: String,
  },
  data() {
    return {
      sectionsOrderByPath: [
        "info",
        "details",
        "hotel",
        "day",
        "activities",
        "download",
        "contacts",
      ],
    };
  },
  methods: {
    /**
     * Cambia la sezione corrente
     * @param {String} path - Il percorso della sezione da visualizzare
     */
    changeSection(path) {
      this.$emit("changeSection", path);
    },

    async scrollToSection(path) {
      if (!this.isValidPath(path)) return false;

      const index = this.findSectionIndex(path);
      if (index === -1) return false;

      return this.performScroll(index);
    },

    isValidPath(path) {
      if (!path) {
        console.warn("Path non valido:", path);
        return false;
      }
      if (!Array.isArray(this.reorderedSections)) {
        console.warn("Sezioni non disponibili");
        return false;
      }
      return true;
    },

    findSectionIndex(path) {
      return this.reorderedSections.findIndex((s) => s.path === path);
    },

    performScroll(index, smooth = true) {
      const carousel = this.$refs.sectionsCarousel;
      if (!carousel) {
        console.warn("Carousel non trovato");
        return Promise.resolve(false);
      }
      return carousel.scrollToElement(index, smooth);
    },
  },
  computed: {
    reorderedSections() {
      return this.sections.slice().sort((a, b) => {
        return (
          this.sectionsOrderByPath.indexOf(a.path) -
          this.sectionsOrderByPath.indexOf(b.path)
        );
      });
    },
  },
};
</script>
